import React from 'react';
import { 
  trackGetStartedClick, 
  trackPurchaseCompleted, 
  trackFormSubmission, 
  trackEmailSignup,
  trackCustomEvent 
} from '../utils/analytics';

// Development component to test all analytics events
// Remove this component in production
const AnalyticsTest = () => {
  const testGetStartedClick = () => {
    trackGetStartedClick('test_button');
  };

  const testPurchaseCompleted = () => {
    trackPurchaseCompleted({
      planName: 'Pro',
      price: 29,
      isAnnual: false,
      currency: 'USD'
    });
  };

  const testFormSubmission = () => {
    trackFormSubmission('test_form', {
      test_parameter: 'test_value',
      form_type: 'analytics_test'
    });
  };

  const testEmailSignup = () => {
    trackEmailSignup('analytics_test');
  };

  const testCustomEvent = () => {
    trackCustomEvent('custom_test_event', {
      test_param_1: 'value1',
      test_param_2: 'value2',
      event_category: 'testing'
    });
  };

  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      background: '#333',
      color: 'white',
      padding: '15px',
      borderRadius: '8px',
      zIndex: 9999,
      fontSize: '12px',
      maxWidth: '250px'
    }}>
      <h4 style={{ margin: '0 0 10px 0', fontSize: '14px' }}>Analytics Test Panel</h4>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
        <button onClick={testGetStartedClick} style={buttonStyle}>
          Test Get Started Click
        </button>
        <button onClick={testPurchaseCompleted} style={buttonStyle}>
          Test Purchase Completed
        </button>
        <button onClick={testFormSubmission} style={buttonStyle}>
          Test Form Submission
        </button>
        <button onClick={testEmailSignup} style={buttonStyle}>
          Test Email Signup
        </button>
        <button onClick={testCustomEvent} style={buttonStyle}>
          Test Custom Event
        </button>
      </div>
      <p style={{ margin: '10px 0 0 0', fontSize: '10px', opacity: 0.7 }}>
        Check browser console for event logs
      </p>
    </div>
  );
};

const buttonStyle = {
  background: '#007bff',
  color: 'white',
  border: 'none',
  padding: '5px 8px',
  borderRadius: '4px',
  cursor: 'pointer',
  fontSize: '11px'
};

export default AnalyticsTest;